




import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class AuthLogoutView extends Vue {
  @Action("session/userLogout")
  private logout!: () => void;

  public mounted() {
    this.logout();
  }
}
